module.exports = __webpack_public_path__ + "media/images/elms logo 2-914bb132f78f6f1388e410829ca9f340.svg";